// Generated by Melange

import * as Cn from "../../../../vendored/classnames/Cn.js";
import * as JsxRuntime from "react/jsx-runtime";

const h1 = "font-extrabold text-3-5xl tracking-[-0.64px]";

const h2 = "font-bold text-2xl";

const h3 = "font-mediumbold text-m tracking-tight";

const h4 = "font-mediumbold text-base";

const h5 = "font-semibold text-sm";

const h6 = "font-semibold text-xs";

const paragraphLarge = "font-normal text-lg";

const paragraph = "font-normal text-base";

const paragraphSmall = "font-normal text-sm";

const caption = "text-xs";

const label = "font-mediumbold text-xs tracking-wider flex items-center uppercase";

const labelSmall = "font-semibold text-xss tracking-wider flex items-center uppercase";

const withIcon = "flex items-center select-none whitespace-nowrap";

const no_wrap = "whitespce-nowrap overflow-hidden text-ellipsis";

const Styles = {
  h1: h1,
  h2: h2,
  h3: h3,
  h4: h4,
  h5: h5,
  h6: h6,
  paragraphLarge: paragraphLarge,
  paragraph: paragraph,
  paragraphSmall: paragraphSmall,
  caption: caption,
  label: label,
  labelSmall: labelSmall,
  withIcon: withIcon,
  no_wrap: no_wrap
};

function Text$H1(Props) {
  let nowrapOpt = Props.nowrap;
  let className = Props.className;
  let children = Props.children;
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const className$1 = Cn.fromList({
    hd: h1,
    tl: {
      hd: Cn.on(no_wrap, nowrap),
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    }
  });
  return JsxRuntime.jsx("div", {
    children: children,
    className: className$1
  });
}

const H1 = {
  make: Text$H1
};

function Text$H2(Props) {
  let nowrapOpt = Props.nowrap;
  let className = Props.className;
  let children = Props.children;
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const className$1 = Cn.fromList({
    hd: h2,
    tl: {
      hd: Cn.on(no_wrap, nowrap),
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    }
  });
  return JsxRuntime.jsx("div", {
    children: children,
    className: className$1
  });
}

const H2 = {
  make: Text$H2
};

function Text$H3(Props) {
  let nowrapOpt = Props.nowrap;
  let className = Props.className;
  let children = Props.children;
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const className$1 = Cn.fromList({
    hd: h3,
    tl: {
      hd: Cn.on(no_wrap, nowrap),
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    }
  });
  return JsxRuntime.jsx("div", {
    children: children,
    className: className$1
  });
}

const H3 = {
  make: Text$H3
};

function Text$H4(Props) {
  let nowrapOpt = Props.nowrap;
  let className = Props.className;
  let children = Props.children;
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const className$1 = Cn.fromList({
    hd: h4,
    tl: {
      hd: Cn.on(no_wrap, nowrap),
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    }
  });
  return JsxRuntime.jsx("div", {
    children: children,
    className: className$1
  });
}

const H4 = {
  make: Text$H4
};

function Text$H5(Props) {
  let nowrapOpt = Props.nowrap;
  let className = Props.className;
  let titleOpt = Props.title;
  let children = Props.children;
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const title = titleOpt !== undefined ? titleOpt : "";
  const className$1 = Cn.fromList({
    hd: h5,
    tl: {
      hd: Cn.on(no_wrap, nowrap),
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    }
  });
  return JsxRuntime.jsx("div", {
    children: children,
    className: className$1,
    title: title
  });
}

const H5 = {
  make: Text$H5
};

function Text$H6(Props) {
  let nowrapOpt = Props.nowrap;
  let className = Props.className;
  let children = Props.children;
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const className$1 = Cn.fromList({
    hd: h6,
    tl: {
      hd: Cn.on(no_wrap, nowrap),
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    }
  });
  return JsxRuntime.jsx("div", {
    children: children,
    className: className$1
  });
}

const H6 = {
  make: Text$H6
};

function Text$PLarge(Props) {
  let nowrapOpt = Props.nowrap;
  let className = Props.className;
  let children = Props.children;
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const className$1 = Cn.fromList({
    hd: paragraphLarge,
    tl: {
      hd: Cn.on(no_wrap, nowrap),
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    }
  });
  return JsxRuntime.jsx("div", {
    children: children,
    className: className$1
  });
}

const PLarge = {
  make: Text$PLarge
};

function Text$P(Props) {
  let nowrapOpt = Props.nowrap;
  let className = Props.className;
  let children = Props.children;
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const className$1 = Cn.fromList({
    hd: paragraph,
    tl: {
      hd: Cn.on(no_wrap, nowrap),
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    }
  });
  return JsxRuntime.jsx("div", {
    children: children,
    className: className$1
  });
}

const P = {
  make: Text$P
};

function Text$PSmall(Props) {
  let nowrapOpt = Props.nowrap;
  let classNameOpt = Props.className;
  let titleOpt = Props.title;
  let onMouseEnterOpt = Props.onMouseEnter;
  let onMouseLeaveOpt = Props.onMouseLeave;
  let children = Props.children;
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const className = classNameOpt !== undefined ? classNameOpt : "text-black";
  const title = titleOpt !== undefined ? titleOpt : "";
  const onMouseEnter = onMouseEnterOpt !== undefined ? onMouseEnterOpt : (function (param) {
      
    });
  const onMouseLeave = onMouseLeaveOpt !== undefined ? onMouseLeaveOpt : (function (param) {
      
    });
  const className$1 = Cn.fromList({
    hd: paragraphSmall,
    tl: {
      hd: Cn.on(no_wrap, nowrap),
      tl: {
        hd: className,
        tl: /* [] */ 0
      }
    }
  });
  return JsxRuntime.jsx("div", {
    children: children,
    className: className$1,
    title: title,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  });
}

const PSmall = {
  make: Text$PSmall
};

function Text$Caption(Props) {
  let nowrapOpt = Props.nowrap;
  let className = Props.className;
  let children = Props.children;
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const className$1 = Cn.fromList({
    hd: caption,
    tl: {
      hd: Cn.on(no_wrap, nowrap),
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    }
  });
  return JsxRuntime.jsx("div", {
    children: children,
    className: className$1
  });
}

const Caption = {
  make: Text$Caption
};

function Text$Label(Props) {
  let nowrapOpt = Props.nowrap;
  let className = Props.className;
  let children = Props.children;
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const className$1 = Cn.fromList({
    hd: label,
    tl: {
      hd: Cn.on(no_wrap, nowrap),
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    }
  });
  return JsxRuntime.jsx("div", {
    children: children,
    className: className$1
  });
}

const Label = {
  make: Text$Label
};

function Text$LabelSmall(Props) {
  let nowrapOpt = Props.nowrap;
  let className = Props.className;
  let children = Props.children;
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const className$1 = Cn.fromList({
    hd: labelSmall,
    tl: {
      hd: Cn.on(no_wrap, nowrap),
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    }
  });
  return JsxRuntime.jsx("div", {
    children: children,
    className: className$1
  });
}

const LabelSmall = {
  make: Text$LabelSmall
};

function Text$Span(Props) {
  let className = Props.className;
  let nowrapOpt = Props.nowrap;
  let children = Props.children;
  const nowrap = nowrapOpt !== undefined ? nowrapOpt : false;
  const className$1 = Cn.fromList({
    hd: Cn.on(no_wrap, nowrap),
    tl: {
      hd: Cn.take(className),
      tl: /* [] */ 0
    }
  });
  return JsxRuntime.jsx("span", {
    children: children,
    className: className$1
  });
}

const Span = {
  make: Text$Span
};

function Text$TextWithIcon(Props) {
  let icon = Props.icon;
  let text = Props.text;
  let className = Props.className;
  let marginOpt = Props.margin;
  const margin = marginOpt !== undefined ? marginOpt : "m-2";
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: icon,
        className: margin
      }),
      text
    ],
    className: Cn.fromList({
      hd: withIcon,
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    })
  });
}

const TextWithIcon = {
  make: Text$TextWithIcon
};

export {
  Styles,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  PLarge,
  P,
  PSmall,
  Caption,
  Label,
  LabelSmall,
  Span,
  TextWithIcon,
}
/* react/jsx-runtime Not a pure module */
